'use strict';
const trackingUtils = require('../modules/utils/tracking.utils');
let changedPNRsForMoreInfo;
let airlineListForMoreInfo;

const PROVIDER_TYPE = {
    '1A': 'GDS',
    'TF': 'TF',
    'VY': 'VLG',
    'NA': 'NA',
    'default': 'XFARE',
};
const TRIP_TYPE = {
    'ONE_WAY': 'OW',
    'ROUND_TRIP': 'RT',
    'MULTIPLE_DESTINATIONS': 'MD',
    'MULTI_SEGMENT': 'MD',
};
const getScenarioParam = function(changedPNRs = {}, airlineList = {}) {
    const airlineListKeys = Object.keys(airlineList);
    const totalListOfCarriers = Object.keys(changedPNRs).map((pnr) => changedPNRs[pnr].validatingCarrier.code);
    const scenario = totalListOfCarriers.map((x) => {
        return airlineListKeys.includes(x) ? x : 'UNHANDLED';
    });
    return scenario.join('-');
};
const getPageParam = function(bkDetail, shownOnMyTrips) {
    let pagParam = 'my';
    const currentPageCode = shownOnMyTrips ? 'tr' : 'ar';
    const productCode = Odigeo._.isEmpty(bkDetail.accommodationBooking)? 'fl' : 'dp';
    return `${pagParam}${currentPageCode}${productCode}`;
};
const getTripTypeParam = function(bkDetail) {
    return TRIP_TYPE[bkDetail.itineraryBookings.bookingItinerary.tripType];
};
const getTripProviderParam = function(changedPNRs) {
    const totalListOfProviders = Object.keys(changedPNRs).map((pnr) => changedPNRs[pnr].sections.map((x) => PROVIDER_TYPE[x.provider]));
    return totalListOfProviders.join('-');
};
const getIatasParam = function(changedPNRs) {
    const totalListOfIatas = Object.keys(changedPNRs).map((pnr) => changedPNRs[pnr].validatingCarrier.code);
    return totalListOfIatas.join('-');
};
const getTrackingData = (bkDetail, changedPNRs) => {
    return {
        meta: Odigeo.SessionScope.isMeta ? '1' : '0',
        type: getTripTypeParam(bkDetail),
        prov: getTripProviderParam(changedPNRs) || PROVIDER_TYPE['default'],
        pax: bkDetail.travellers.length,
        iata: getIatasParam(changedPNRs),
    };
};
/**
 *
 * @param {Object} bkDetail - Object with all the booking Info stored in session.
 * @param {Object} changedPNRs - Object containing the PNRs that have changed status and some basic info
 * @param {Object} airlineList - Array with containing the airlines handled.
 * @param {Boolean} shownOnMyTrips - Boolean only passed through as true when tracking called from #myTrips.
 * @return {String} with label needed for tracking depending on scenario.
 */
const trackItineraryStatusOnLoad = function(bkDetail, changedPNRs, airlineList, shownOnMyTrips = false) {
    const action = 'cancellation_message';
    const scenario = `_sce:${getScenarioParam(changedPNRs, airlineList)}`;
    const page = `_pag:${getPageParam(bkDetail, shownOnMyTrips)}`;
    const labelPrefix = `cancellation_message_onload${scenario}${page}`;
    changedPNRsForMoreInfo = changedPNRs;
    airlineListForMoreInfo = airlineList;

    sendTrack({
        action,
        labelPrefix,
        data: getTrackingData(bkDetail, changedPNRs),
    });
    return labelPrefix;
};
/**
 *
 * @param {Object} bkDetail - Object with all the booking Info stored in session.
 * @param {Object} changedPNRs - Object containing the PNRs that have changed status and some basic info
 * @param {Object} airlineList - Array with containing the airlines handled.
 * @param {String} clickedAction - Tells how to handle the booking depending on its conditions.
 * @return {String} with label needed for tracking depending on scenario.
 */
const trackTripDetailsInvCanxWidgetOnClick = function(bkDetail, changedPNRs, airlineList, clickedAction) {
    const action = 'cancellation_message';
    const scenario = `_sce:${getScenarioParam(changedPNRs, airlineList)}`;
    const typeOfActionRequired = clickedAction === 'GO_TO_MMB' ? 'manage' : 'contact';
    const page = `_pag:${getPageParam(bkDetail)}`;
    const labelPrefix = `cancellation_message_click:${typeOfActionRequired}${scenario}${page}`;
    sendTrack({
        action,
        labelPrefix,
        data: getTrackingData(bkDetail, changedPNRs),
    });
    return labelPrefix;
};
/**
 *
 * @param {Object} bkDetail - Object with all the booking Info stored in session.
 * @param {Object} changedPNRs - Object containing the PNRs that have changed status and some basic info
 * @param {Object} airlineList - Array with containing the airlines handled.
 * @return {String} with label needed for tracking depending on scenario.
 */
const trackTripDetailsOnPopupClicks = function(bkDetail, changedPNRs, airlineList) {
    const action = 'cancellation_message';
    const scenario = `_sce:${getScenarioParam(changedPNRs, airlineList)}`;
    const page = `_pag:${getPageParam(bkDetail)}`;
    const labelPrefix = `cancellation_popup_click:contact${scenario}${page}`;
    sendTrack({
        action,
        labelPrefix,
        data: getTrackingData(bkDetail, changedPNRs),
    });
    return labelPrefix;
};
/**
 *
 * @param {Object} bkDetail - Object with all the booking Info stored in session.
 * @param {String} clickedPNRIndex - Tells what more info link has been clicked.
 * @param {Object} changedPNRsMoreInfo - Object containing data on the changed PNRs stored onLoad.
 * @param {Object} airlineListMoreInfo - rray with containing the airlines handled.
 * @return {String} with label needed for tracking depending on scenario.
 */
const trackTripDetailsOnSummaryMoreInfoLinkClick = function(bkDetail, clickedPNRIndex,
    changedPNRsMoreInfo = changedPNRsForMoreInfo, airlineListMoreInfo = airlineListForMoreInfo) {
    const action = 'cancellation_message';
    const PNRsArray = Object.keys(changedPNRsMoreInfo);
    const targetPNR = PNRsArray[clickedPNRIndex];
    const clickedValidatingCarrier = changedPNRsMoreInfo[targetPNR].validatingCarrier.code;
    const isContact = (clickedValidatingCarrier === 'VY' || clickedValidatingCarrier === 'FR');
    const scenario = `_sce:${getScenarioParam(changedPNRsMoreInfo, airlineListMoreInfo)}`;
    const page = `_pag:${getPageParam(bkDetail)}`;
    const labelPrefix = `cancellation_link_click:${isContact ? 'contact' : 'manage'}${scenario}${page}`;
    sendTrack({
        action,
        labelPrefix,
        data: getTrackingData(bkDetail, changedPNRsMoreInfo),
    });
    return labelPrefix;
};
const buildLabel = (params) => {
    const label = [
        params.labelPrefix,
        '_meta:',
        Odigeo._.get(params, 'data.meta'),
        '_type:',
        Odigeo._.get(params, 'data.type'),
        '_prov:',
        Odigeo._.get(params, 'data.prov'),
        '_pax:',
        Odigeo._.get(params, 'data.pax'),
        '_iata:',
        Odigeo._.get(params, 'data.iata'),
    ];
    return label.join('');
};
const getMyTripsOnClickScenarioAndPageParams = function(bkDetail, myTripschangedPNRs, airlineListMoreInfo) {
    return `_sce:${getScenarioParam(myTripschangedPNRs, airlineListMoreInfo)}_pag:${getPageParam(bkDetail, true)}`;
};
const sendTrack = (params) => {
    trackingUtils.trackEvent(params.action, buildLabel(params));
};

module.exports = {
    trackItineraryStatusOnLoad,
    trackTripDetailsInvCanxWidgetOnClick,
    trackTripDetailsOnPopupClicks,
    trackTripDetailsOnSummaryMoreInfoLinkClick,
    getMyTripsOnClickScenarioAndPageParams,
};
